import { useEffect, useState } from 'react'

import { createStatusSnapshot } from '../../lib/statusTicker.js'

export function StatusTicker({ reducedMotion = false, location = 'hero' }) {
  const [snapshot, setSnapshot] = useState(() => createStatusSnapshot(0))

  useEffect(() => {
    if (reducedMotion) return undefined
    const started = performance.now()
    const id = window.setInterval(() => {
      setSnapshot(createStatusSnapshot(performance.now() - started))
    }, 1500)
    return () => window.clearInterval(id)
  }, [reducedMotion])

  return (
    <div className={`status-ticker status-ticker--${location}`} aria-label={snapshot.label}>
      {snapshot.segments.map((segment) => (
        <span key={segment.code}>
          <strong>{segment.code}</strong>
          <i aria-hidden="true">●</i>
          <em>{segment.value}</em>
        </span>
      ))}
    </div>
  )
}
